import Vue from 'vue';
import { v4 as uuid } from 'uuid';

import router from '../router';
import trade from './trade';
import requests from './requests';

const VueRouter = router.history.router;

Vue.mixin({
	computed: {
		isMobile() {
			return this.$store.getters.window_size.width <= 768;
		}
	},
	methods: {
		goBack: (where = 'history') => {
			if (where === 'parent') {
				let parent = VueRouter.history.current.matched[0].path.substr(1);

				router.push({
					name: parent
				});
			} else {
				router.go(-1);
			}
		},
		hideAlert() {
			$('.alert')
				.fadeTo(500, 0)
				.slideUp(500, function() {
					$(this).remove();
				});
		},
		hasChildActive: route => {
			const paths = Array.isArray(route) ? route : [route];

			return paths.some(path => {
				return VueRouter.currentRoute.path.indexOf(path) === 0;
			});
		},
		portfolioPerformanceIndicators(value, target) {
			let performance = 0;
			let progress = 0;

			value = parseFloat(value);
			target = parseFloat(target);

			if (value !== 0.0 && target !== 0.0) {
				performance = value / target;
				progress = _.round(performance.toFixed(2) * 100, -1);
			}

			performance = performance.toFixed(2);

			return {
				performance,
				progress: progress > 100 ? 100 : progress
			};
		},
		requestType(type, icon, bg) {
			if (icon) {
				const _icon = {
					withdrawal: 'arrow-up-right',
					deposit: 'arrow-down-left'
				};

				return `<i data-feather="${_icon[type]}"></i>`;
			}

			if (bg) {
				const _bg = {
					withdrawal: 'bg-warning',
					deposit: 'bg-success'
				};

				return _bg[type];
			}

			return _.startCase(`${type} Request`);
		},
		requestStatus(status) {
			const _class = {
				pending: 'badge-outline-info',
				approved: 'badge-outline-success',
				declined: 'badge-outline-danger'
			};

			return `<span class="badge badge-sm ${_class[status.toLowerCase()]} d-none d-md-inline-flex">${status.toUpperCase()}</span>`;
		},
		transactionType(type, icon, bg) {
			if (icon) {
				const _icon = {
					withdraw: 'arrow-up-right',
					deposit: 'arrow-down-left',
					sell: 'arrow-up-right',
					buy: 'arrow-down-left',
					fees: 'percent'
				};

				return `<i data-feather="${_icon[type.toLowerCase()]}"></i>`;
			}

			if (bg) {
				const _bg = {
					withdraw: 'bg-warning',
					deposit: 'bg-success',
					sell: 'bg-danger',
					buy: 'bg-info',
					fees: 'bg-success'
				};

				return _bg[type.toLowerCase()];
			}

			return _.startCase(`${type} Transaction`);
		},
		feeStatus(status) {
			const _class = {
				pending: 'badge-outline-info',
				processed: 'badge-outline-success'
			};

			return `<span class="badge badge-sm badge-dim ${_class[status.toLowerCase()]} d-none d-md-inline-flex">${status.toUpperCase()}</span>`;
		},
		approvalIcon(type, status) {
			let style = '';
			let icon = 'loader';

			switch (type) {
				case 'request':
					style = 'bd-warning tx-warning';
					icon = 'arrow-up-right';
					break;
				default:
					style = 'bd-warning tx-warning';
					icon = 'settings';
					break;
			}

			if (status !== 'pending') {
				if (status === 'approved') {
					style = 'bd-success tx-success';
				} else {
					style = 'bd-danger tx-danger';
				}
			}

			return `<div class="wd-40 ht-40 bd bd-2 ${style} rounded-circle request-status op-6">` + `<i data-feather="${icon}" class="wd-40"></i>` + `</div>`;
		},
		approvalStatus(status) {
			const _class = {
				pending: 'badge-outline-warning',
				approved: 'badge-outline-success',
				declined: 'badge-outline-danger',
				cancelled: 'badge-outline-danger'
			};

			return `<span class="badge rounded-pill badge-sm badge-dim w-100 border-0 ${_class[status.toLowerCase()]}">${status.toUpperCase()}</span>`;
		},
		approvalType(type, data) {
			let text = 'Unknown Request Type';

			switch (type) {
				case 'request':
					text = _.startCase(data.type);
					break;
				default:
					text = `Company ${_.startCase(type)} Update`;
					break;
			}

			return `${text} Request`;
		},
		generateUuid(hyphenated = false) {
			if (hyphenated) {
				return uuid();
			}

			return uuid().replace(/-/g, '');
		},
		isEmpty(data) {
			return _.isEmpty(data);
		}
	}
});

export { requests, trade };
